import type { API } from 'chessboard/api/config/types';
import type { Game } from 'model/game/types';

/**
 * Create the getRawLines method.
 */
export function createGetRawLines(context: API.Context) {
  /**
   * Get the JCE lines
   */
  return function getRawLines(): Game.Line[] {
    const { game } = context;

    return game._lines(); // eslint-disable-line
  };
}
